import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { AuthLayout } from "@/components/AuthLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [devLink, setDevLink] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(true);
      setDevLink(data.data?.reset_link || null);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Recupera password" subtitle="Ti invieremo le istruzioni per reimpostare la password">
      {sent ? (
        <div className="space-y-4" data-testid="forgot-sent">
          <div className="flex items-center gap-3 rounded-xl border border-primary/30 bg-primary/5 p-4">
            <MailCheck className="h-6 w-6 text-primary" />
            <p className="text-sm">Se l'email esiste, riceverai un link per reimpostare la password.</p>
          </div>
          {devLink && (
            <div className="rounded-lg border border-dashed border-amber-500/40 bg-amber-500/10 p-3 text-xs">
              <p className="mb-1 font-medium text-amber-600">Modalità sviluppo (email mock):</p>
              <Link to={devLink} className="break-all text-primary underline" data-testid="dev-reset-link">{devLink}</Link>
            </div>
          )}
          <Link to="/login"><Button variant="outline" className="w-full rounded-lg">Torna al login</Button></Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div className="space-y-2">
            <Label>Email</Label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />
          </div>
          <Button type="submit" className="w-full rounded-lg" disabled={loading} data-testid="forgot-submit">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Invia istruzioni
          </Button>
          <p className="text-center text-sm text-muted-foreground">
            <Link to="/login" className="text-primary hover:underline">Torna al login</Link>
          </p>
        </form>
      )}
    </AuthLayout>
  );
}
